import { Dialog, DialogContent } from "@mui/material";
import styles from "./Popup.module.scss";

interface PopupProps {
  open: boolean;
  onClose: () => void;
  content: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  padding?: boolean;
}

const Popup: React.FC<PopupProps> = ({
  open,
  onClose,
  content,
  maxWidth = "sm",
  padding = true,
}) => {
  const containerStyle = padding ? "container" : "container-no-padding";
  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth={true}
      maxWidth={maxWidth}
      PaperProps={{
        style: { borderRadius: 16 },
      }}
    >
      <DialogContent>
        <div className={styles[containerStyle]}>{content}</div>
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
